<template>
  <div class="fixed menu-left m-left-menu-top">
    <div class="px-4">
      <a :href="base_url()" aria-current="page" class="nuxt-link-exact-active nuxt-link-active">
        <img src="@/assets/images/menu/support_logo.png" class="c-side-menu__title">
      </a>
      <ul class="fixed menu-left m-left-menu-left m-left-menu-right">
        <li class="h-20 mr-4 pt-2 px-4 mt-4 bg-white border rounded-2xl border-gray-300 shadow-md"><a :href="base_url() + '/ekitomaticket/external/map/current'" class="c-side-menu__bannerLink"><img src="@/assets/images/menu/pc-button-large-01.svg"></a></li>
        <li class="h-20 mr-4 pt-2 px-4 mt-4 bg-white border rounded-2xl border-gray-300 shadow-md"><a :href="base_url() + '/portal/spots'" class="c-side-menu__bannerLink"><img src="@/assets/images/menu/pc-button-large-02.svg"></a></li>
        <li class="h-16 mr-4 pt-3 px-4 mt-4 bg-white border rounded-2xl border-gray-300 shadow-md"><a :href="base_url() + '/portal/external/modelCourse'" class="c-side-menu__bannerLink"><img src="@/assets/images/menu/pc-button-large-03.svg"></a></li>
        <li class="h-16 mr-4 pt-3 px-4 mt-4 bg-white border rounded-2xl border-gray-300 shadow-md"><a href="https://transit.jre-maas.com/" target="_blank" class="c-side-menu__bannerLink"><img src="@/assets/images/menu/pc-button-large-04.svg"></a></li>
      </ul>
    </div>
    <ul class="fixed menu-left text-gray-400 text-xs bottom-4 p-2">
      <div class="float-left">※</div>
      <li class="ml-4">Tabi-CONNECTはスマートフォン向けサービスです。PCでは一部表示されないコンテンツがございますのでご了承ください。</li>
      <div class="float-left">※</div>
      <li class="ml-4">※電子チケットをご利用いただく際には、Tabi-CONNECTにログインのうえ、電子チケット画面を表示する必要があります。スクリーンショットではご利用いただけません。</li>
    </ul>
  </div>
</template>

<script>
import Constants from "../../constants";

export default {
  name: 'TheHeader',
  methods: {
    base_url: function () {
      return Constants.LINK_BASE_URL
    }
  }
}
</script>
